import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styles: []
})
export class FooterComponent {
urlFaq:string=`${window.location.origin}/faq`
  modalTerms: boolean;

  constructor() { }

  toggleModalTerms(): void {
    this.modalTerms = !this.modalTerms
  }


}
